import LabeledIconButton from './LabeledIconButton';

export default LabeledIconButton;
export * from './LabeledIconButton';
